import { Component, ViewChild } from '@angular/core';
//import { DxDataGridComponent } from 'devextreme-angular/ui/data-grid';

@Component({
    selector: 'pds-dx-data-grid',
    templateUrl: './pds-dx-data-grid.component.html',
    styleUrls: ['./pds-dx-data-grid.component.css']
})
export class PdsDxDataGridComponent /*extends DxDataGridComponent *//*implements OnDestroy, OnChanges, DoCheck*/ {
   // @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;
    
    onToolbarPreparing1(e: any) {
        e.toolbarOptions.items.unshift({
            location: 'after',
            widget: 'dxButton',
            options: {
                icon: 'refresh',
                //onClick: this.refreshDataGrid.bind(this)
            }
        },
            /*{
                location: 'after',
                widget: 'dxButton',
                options: {
                    hint: 'Restore Defaults',
                    icon: 'preferences',
                    //onClick: this.onRestore.bind(this)
                }
            },*/
            {
                location: 'after',
                widget: 'dxDropDownMenu',
                options: {
                    hint: 'Options',
                    buttonIcon: 'preferences',
                    items: [{
                        'text': 'Reset to Default',
                        buttonIcon: 'pulldown',
                        //onClick: this.onRestore.bind(this)
                    },
                    {
                        'text': 'Reset Sorting',
                        'icon': 'pulldown',
                        //onClick: this.onResetSorting.bind(this)
                    },
                    {
                        'text': 'Reset Grouping',
                        'icon': 'pulldown',
                        //onclick: this.onResetGrouping.bind(this)
                    }],
                }
            }/*,
            {
                locateInMenu: 'always',
                text: 'Save',
            },
            {
                locateInMenu: 'always',
                text: 'Print',
            }, {
                locateInMenu: 'always',
                text: 'Settings',
            }*/
        );
    }
    /*onRestore() {
        if (confirm('Are you sure you want to restore grid defaults ?')) {
            localStorage.removeItem(this.dataGrid.stateStoring.storageKey);
            location.reload();//TODO: change this to releoad grid only, might be able to do via angular forms
        }
    }
    onResetSorting() {
        for (let i: number = 0; i < this.dataGrid.instance.columnCount(); i++) {
            this.dataGrid.instance.columnOption(i, "sortOrder", undefined);
        }
    }
    onResetGrouping() {
        for (let i: number = 0; i < this.dataGrid.instance.columnCount(); i++) {
            this.dataGrid.instance.columnOption(i, "groupOrder", undefined);
        }
    }
    refreshDataGrid() {
        this.dataGrid.instance.refresh();
    }*/
}
